export default __webpack_public_path__ + "static/media/two_three.3efce3e4.png";